import { render, staticRenderFns } from "./CompleteList.vue?vue&type=template&id=65459af8&scoped=true&"
import script from "./CompleteList.vue?vue&type=script&lang=js&"
export * from "./CompleteList.vue?vue&type=script&lang=js&"
import style0 from "./CompleteList.vue?vue&type=style&index=0&id=65459af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65459af8",
  null
  
)

export default component.exports